/*!
 * TinyMCE Language Pack
 *
 * Copyright (c) 2022 Ephox Corporation DBA Tiny Technologies, Inc.
 * Licensed under the Tiny commercial license. See https://www.tiny.cloud/legal/
 */
(function () {
    if (typeof document == 'undefined') return;
    tinymce.addI18n('sk', {
    "Redo": "Znova",
    "Undo": "Späť",
    "Cut": "Vystrihnúť",
    "Copy": "Kopírovať",
    "Paste": "Prilepiť",
    "Select all": "Označiť všetko",
    "New document": "Nový dokument",
    "Ok": "Ok",
    "Cancel": "Zrušiť",
    "Visual aids": "Vizuálne pomôcky",
    "Bold": "Tučné",
    "Italic": "Kurzíva",
    "Underline": "Podčiarknuté",
    "Strikethrough": "Prečiarknuté",
    "Superscript": "Horný index",
    "Subscript": "Dolný index",
    "Clear formatting": "Vymazať formátovanie",
    "Remove": "Odstrániť",
    "Align left": "Zarovnať vľavo",
    "Align center": "Zarovnať na stred",
    "Align right": "Zarovnať vpravo",
    "No alignment": "Bez zarovnania",
    "Justify": "Zarovnať",
    "Bullet list": "Zoznam s odrážkami",
    "Numbered list": "Číslovaný zoznam",
    "Decrease indent": "Zmenšiť odsadenie",
    "Increase indent": "Zväčšiť odsadenie",
    "Close": "Zatvoriť",
    "Formats": "Formáty",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Váš prehliadač nepodporuje priamy prístup do schránky. Použite klávesové skratky Ctrl+X/C/V.",
    "Headings": "Nadpisy",
    "Heading 1": "Nadpis 1",
    "Heading 2": "Nadpis 2",
    "Heading 3": "Nadpis 3",
    "Heading 4": "Nadpis 4",
    "Heading 5": "Nadpis 5",
    "Heading 6": "Nadpis 6",
    "Preformatted": "Predformátované",
    "Div": "Div",
    "Pre": "Pre",
    "Code": "Kód",
    "Paragraph": "Odstavec",
    "Blockquote": "Citácia",
    "Inline": "Vložené štýly",
    "Blocks": "Bloky",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Vkladanie je v móde neformátovaného textu. Vkladaný obsah bude vložený ako neformátovaný, až pokým túto možnosť nevypnete.",
    "Fonts": "Typy písma",
    "Font sizes": "Veľkosti písma",
    "Class": "Trieda",
    "Browse for an image": "Nájsť obrázok",
    "OR": "ALEBO",
    "Drop an image here": "Pretiahnite obrázok sem",
    "Upload": "Nahrať",
    "Uploading image": "Nahrávam obrázok",
    "Block": "Blok",
    "Align": "Zarovnať",
    "Default": "Východzie",
    "Circle": "Kruhový",
    "Disc": "Oválny",
    "Square": "Štvorcový",
    "Lower Alpha": "Malé písmená",
    "Lower Greek": "Malé grécke písmená",
    "Lower Roman": "Malé rímske číslice",
    "Upper Alpha": "Veľké písmená",
    "Upper Roman": "Veľké rímske číslice",
    "Anchor...": "Kotva...",
    "Anchor": "Kotva",
    "Name": "Názov",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "",
    "You have unsaved changes are you sure you want to navigate away?": "Máte neuložené zmeny, naozaj chcete opustiť stránku?",
    "Restore last draft": "Obnoviť posledný koncept",
    "Special character...": "Špeciálny znak...",
    "Special Character": "Špeciálny znak",
    "Source code": "Zdrojový kód",
    "Insert/Edit code sample": "Vložiť/upraviť vzorku kódu",
    "Language": "Jazyk",
    "Code sample...": "Vzorka kódu...",
    "Left to right": "Zľava doprava",
    "Right to left": "Sprava doľava",
    "Title": "Nadpis",
    "Fullscreen": "Na celú obrazovku",
    "Action": "Úkon",
    "Shortcut": "Odkaz",
    "Help": "Pomocník",
    "Address": "Adresa",
    "Focus to menubar": "Zameranie na panel s ponukami",
    "Focus to toolbar": "Zameranie na panel s nástrojmi",
    "Focus to element path": "Zameranie na cestu prvku",
    "Focus to contextual toolbar": "Zameranie na kontextový panel s nástrojmi",
    "Insert link (if link plugin activated)": "Vložiť odkaz (ak je aktivovaný plugin odkazu)",
    "Save (if save plugin activated)": "Uložiť (ak je aktivovaný plugin uloženia)",
    "Find (if searchreplace plugin activated)": "Nájsť (ak je aktivovaný plugin vyhľadávania)",
    "Plugins installed ({0}):": "Nainštalované pluginy ({0}):",
    "Premium plugins:": "Prémiové pluginy:",
    "Learn more...": "Zisti viac...",
    "You are using {0}": "Používate {0}",
    "Plugins": "Pluginy",
    "Handy Shortcuts": "Užitočné odkazy",
    "Horizontal line": "Horizontálna čiara",
    "Insert/edit image": "Vložiť/upraviť obrázok",
    "Alternative description": "Alternatívny popis",
    "Accessibility": "Dostupnosť",
    "Image is decorative": "Obrázok je dekoratívny",
    "Source": "Zdroj",
    "Dimensions": "Rozmery",
    "Constrain proportions": "Obmedzenie proporcií",
    "General": "Základné",
    "Advanced": "Pokročilé",
    "Style": "Štýl",
    "Vertical space": "Vertikálny priestor",
    "Horizontal space": "Horizontálny priestor",
    "Border": "Orámovanie",
    "Insert image": "Vložiť obrázok",
    "Image...": "Obrázok...",
    "Image list": "Zoznam obrázkov",
    "Resize": "Zmeniť veľkosť",
    "Insert date/time": "Vložiť dátum/čas",
    "Date/time": "Dátum/čas",
    "Insert/edit link": "Vložiť/upraviť odkaz",
    "Text to display": "Text na zobrazenie",
    "Url": "",
    "Open link in...": "Otvoriť odkaz v...",
    "Current window": "Aktuálne okno",
    "None": "Žiadne",
    "New window": "Nové okno",
    "Open link": "Otvoriť linku",
    "Remove link": "Odstrániť odkaz",
    "Anchors": "Kotvy",
    "Link...": "Odkaz...",
    "Paste or type a link": "Prilepte alebo napíšte odkaz",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "URL adresa, ktorú ste zadali je pravdepodobne emailová adresa. Želáte si pridať požadovanú predponu mailto:?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "URL adresa, ktorú ste zadali je pravdepodobne externý odkaz. Chcete pridať požadovanú predponu http://?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "URL, ktorú ste zadali vyzerá ako externý odkaz. Prajete si pridat požadovanú predponu https://?",
    "Link list": "Zoznam odkazov",
    "Insert video": "Vložiť video",
    "Insert/edit video": "Vložiť/upraviť video",
    "Insert/edit media": "Vložiť/upraviť médiá",
    "Alternative source": "Alternatívny zdroj",
    "Alternative source URL": "Alternatívny zdroj URL",
    "Media poster (Image URL)": "Obrázok média (URL obrázka)",
    "Paste your embed code below:": "Vložte kód pre vloženie nižšie:",
    "Embed": "Vložiť",
    "Media...": "Médiá...",
    "Nonbreaking space": "Pevná medzera",
    "Page break": "Zalomenie stránky",
    "Paste as text": "Vložiť ako text",
    "Preview": "Ukážka",
    "Print": "Tlač",
    "Print...": "Tlač...",
    "Save": "Uložiť",
    "Find": "Hľadať",
    "Replace with": "Nahradiť čím",
    "Replace": "Nahradiť",
    "Replace all": "Nahradiť všetko",
    "Previous": "Predchádzajúce",
    "Next": "Nasledujúce",
    "Find and Replace": "Nájsť a nahradiť",
    "Find and replace...": "Nájsť a nahradiť...",
    "Could not find the specified string.": "Zadaný reťazec sa nenašiel.",
    "Match case": "Rozlišovať veľké/malé písmená",
    "Find whole words only": "Hľadať len celé slová",
    "Find in selection": "Nájsť vo výbere",
    "Insert table": "Vložiť tabuľku",
    "Table properties": "Vlastnosti tabuľky",
    "Delete table": "Zmazať tabuľku",
    "Cell": "Bunka",
    "Row": "Riadok",
    "Column": "Stĺpec",
    "Cell properties": "Vlastnosti bunky",
    "Merge cells": "Zlúčiť bunky",
    "Split cell": "Rozdeliť bunku",
    "Insert row before": "Vložiť riadok pred",
    "Insert row after": "Vložiť riadok za",
    "Delete row": "Zmazať riadok",
    "Row properties": "Vlastnosti riadku",
    "Cut row": "Vystrihnúť riadok",
    "Cut column": "Vystrihnúť stĺpec",
    "Copy row": "Kopírovať riadok",
    "Copy column": "Kopírovať stĺpec",
    "Paste row before": "Prilepiť riadok pred",
    "Paste column before": "Vložiť stĺpec pred",
    "Paste row after": "Prilepiť riadok za",
    "Paste column after": "Vložiť stĺpec za",
    "Insert column before": "Vložiť stĺpec pred",
    "Insert column after": "Vložiť stĺpec za",
    "Delete column": "Vymazať stĺpec",
    "Cols": "Stĺpce",
    "Rows": "Riadky",
    "Width": "Šírka",
    "Height": "Výška",
    "Cell spacing": "Rozstup buniek",
    "Cell padding": "Odsadenie v bunkách",
    "Row clipboard actions": "Clipboard akcie nad riadkom",
    "Column clipboard actions": "Clipboard akcie nad stĺpcom",
    "Table styles": "Štýly tabuľky",
    "Cell styles": "Štýly bunky",
    "Column header": "Hlavička stĺpca",
    "Row header": "Hlavička riadku",
    "Table caption": "Nadpis tabuľky",
    "Caption": "Popisok",
    "Show caption": "Zobraziť popis",
    "Left": "Vľavo",
    "Center": "Stred",
    "Right": "Vpravo",
    "Cell type": "Typ bunky",
    "Scope": "Oblasť",
    "Alignment": "Zarovnanie",
    "Horizontal align": "Horizontálne zarovnanie",
    "Vertical align": "Vertikálne zarovnanie",
    "Top": "Vrch",
    "Middle": "Stred",
    "Bottom": "Spodok",
    "Header cell": "Bunka záhlavia",
    "Row group": "Skupina riadkov",
    "Column group": "Skupina stĺpcov",
    "Row type": "Typ riadku",
    "Header": "Hlavička",
    "Body": "Telo",
    "Footer": "Päta",
    "Border color": "Farba orámovania",
    "Solid": "Plná čiara",
    "Dotted": "Bodkované",
    "Dashed": "Čiarkované",
    "Double": "Dvojité",
    "Groove": "Vtlačený okraj",
    "Ridge": "Vystúpený okraj",
    "Inset": "Vtlačené",
    "Outset": "Vystúpené",
    "Hidden": "Skryté",
    "Insert template...": "Vložiť šablónu...",
    "Templates": "Šablóny",
    "Template": "Šablóna",
    "Insert Template": "Vložiť šablónu",
    "Text color": "Farba textu",
    "Background color": "Farba pozadia",
    "Custom...": "Vlastné...",
    "Custom color": "Vlastná farba",
    "No color": "Bez farby",
    "Remove color": "Odstrániť farbu",
    "Show blocks": "Zobraziť bloky",
    "Show invisible characters": "Zobraziť skryté znaky",
    "Word count": "Počet slov",
    "Count": "Počet",
    "Document": "Dokument",
    "Selection": "Výber",
    "Words": "Slová",
    "Words: {0}": "Slová: {0}",
    "{0} words": "{0} slová/slov",
    "File": "Súbor",
    "Edit": "Upraviť",
    "Insert": "Vložiť",
    "View": "Zobraziť",
    "Format": "Formát",
    "Table": "Tabuľka",
    "Tools": "Nástroje",
    "Powered by {0}": "Používa {0}",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Oblasť pre text vo formáte RTF. Stlačte ALT-F9 pre zobrazenie menu. Stlačte ALT-F10 pre zobrazenie panela nástrojov. Stlačte ALT-0 pre nápovedu.",
    "Image title": "Názov obrázka",
    "Border width": "Šírka okraja",
    "Border style": "Štýl okraja",
    "Error": "Chyba",
    "Warn": "Upozornenie",
    "Valid": "Platné",
    "To open the popup, press Shift+Enter": "Na otvorenie kontextovej ponuky stlačte Shift+Enter",
    "Rich Text Area": "Oblasť pre text vo formáte RTF",
    "Rich Text Area. Press ALT-0 for help.": "Oblasť pre text vo formáte RTF. Stlačte ALT-0 pre nápovedu.",
    "System Font": "Systémové písmo",
    "Failed to upload image: {0}": "Obrázok sa nepodarilo nahrať: {0}",
    "Failed to load plugin: {0} from url {1}": "Plugin: {0} sa nepodarilo nahrať z url {1}",
    "Failed to load plugin url: {0}": "Nepodarilo sa nahrať plugin url: {0}",
    "Failed to initialize plugin: {0}": "Nepodarilo sa inicializovať plugin: {0}",
    "example": "príklad",
    "Search": "Vyhľadať",
    "All": "Všetko",
    "Currency": "Mena",
    "Text": "Text",
    "Quotations": "Kvotácie",
    "Mathematical": "Matematické",
    "Extended Latin": "Rozšírená latinka",
    "Symbols": "Symboly",
    "Arrows": "Šípky",
    "User Defined": "Definované používateľom",
    "dollar sign": "znak pre dolár",
    "currency sign": "znak meny",
    "euro-currency sign": "znak eura",
    "colon sign": "znak dvojbodky",
    "cruzeiro sign": "znak pre cruzeiro",
    "french franc sign": "znak pre francúzsky frank",
    "lira sign": "znak pre líru",
    "mill sign": "znak pre mill",
    "naira sign": "znak pre nairu",
    "peseta sign": "znak pre pesetu",
    "rupee sign": "znak pre rupiu",
    "won sign": "znak pre won",
    "new sheqel sign": "znak pre nový šekel",
    "dong sign": "znak pre dong",
    "kip sign": "znak pre kip",
    "tugrik sign": "znak pre tugrik",
    "drachma sign": "znak pre drachmu",
    "german penny symbol": "znak pre nemecký pfennig",
    "peso sign": "znak pre peso",
    "guarani sign": "znak pre guarani",
    "austral sign": "znak pre austral",
    "hryvnia sign": "znak pre hrivnu",
    "cedi sign": "znak pre cedi",
    "livre tournois sign": "znak pre livre tournois",
    "spesmilo sign": "znak pre spesmilo",
    "tenge sign": "znak pre tenge",
    "indian rupee sign": "znak pre indickú rupiu",
    "turkish lira sign": "znak pre tureckú líru",
    "nordic mark sign": "znak pre nordickú marku",
    "manat sign": "znak pre manat",
    "ruble sign": "znak pre rubeľ",
    "yen character": "znak pre jen",
    "yuan character": "znak pre jüan",
    "yuan character, in hong kong and taiwan": "znak pre jüan, v Hongkongu a Taiwane",
    "yen/yuan character variant one": "znak pre jen/jüan variant jedna",
    "Emojis": "Emotikony",
    "Emojis...": "Emotikony...",
    "Loading emojis...": "Nahrávam emotikony...",
    "Could not load emojis": "Nebolo možné nahrať emotikony",
    "People": "Ľudia",
    "Animals and Nature": "Zvieratá a príroda",
    "Food and Drink": "Jedlo a nápoje",
    "Activity": "Aktivity",
    "Travel and Places": "Cestovanie a miesta",
    "Objects": "Objekty",
    "Flags": "Vlajky",
    "Characters": "Znaky",
    "Characters (no spaces)": "Znaky (bez medzier)",
    "{0} characters": "Znaky: {0}",
    "Error: Form submit field collision.": "Chyba: konflikt poľa odosielania formulára.",
    "Error: No form element found.": "Chyba: nenašiel sa prvok formulára.",
    "Color swatch": "Vzorky farieb",
    "Color Picker": "Výber farieb",
    "Invalid hex color code: {0}": "Nesprávny hex kód farby: {0}",
    "Invalid input": "Chybný vstup",
    "R": "Č",
    "Red component": "Červená zložka",
    "G": "Z",
    "Green component": "Zelená zložka",
    "B": "M",
    "Blue component": "Modrá zložka",
    "#": "#",
    "Hex color code": "Hexa kód farby",
    "Range 0 to 255": "Rozsah 0 až 255",
    "Turquoise": "Tyrkysová",
    "Green": "Zelená",
    "Blue": "Modrá",
    "Purple": "Fialová",
    "Navy Blue": "Námornícka modrá",
    "Dark Turquoise": "Tmavotyrkysová",
    "Dark Green": "Tmavozelená",
    "Medium Blue": "Stredná modrá",
    "Medium Purple": "Stredná fialová",
    "Midnight Blue": "Polnočná modrá",
    "Yellow": "Žltá",
    "Orange": "Oranžová",
    "Red": "Červená",
    "Light Gray": "Svetlosivá",
    "Gray": "Sivá",
    "Dark Yellow": "Tmavožltá",
    "Dark Orange": "Tmavooranžová",
    "Dark Red": "Tmavočervená",
    "Medium Gray": "Stredná sivá",
    "Dark Gray": "Tmavosivá",
    "Light Green": "Svetlozelená",
    "Light Yellow": "Svetložltá",
    "Light Red": "Svetločervená",
    "Light Purple": "Svetlofialová",
    "Light Blue": "Svetlomodrá",
    "Dark Purple": "Tmavofialová",
    "Dark Blue": "Tmavomodrá",
    "Black": "Čierna",
    "White": "Biela",
    "Switch to or from fullscreen mode": "Prepnúť do alebo z režimu plnej obrazovky",
    "Open help dialog": "Otvoriť okno nápovedy",
    "history": "história",
    "styles": "štýly",
    "formatting": "formátovanie",
    "alignment": "zarovnanie",
    "indentation": "odsadenie",
    "Font": "Písmo",
    "Size": "Veľkosť",
    "More...": "Viac...",
    "Select...": "Vyberte...",
    "Preferences": "Preferencie",
    "Yes": "Áno",
    "No": "Nie",
    "Keyboard Navigation": "Navigácia pomocou klávesnice",
    "Version": "Verzia",
    "Code view": "Zobrazenie kódu",
    "Open popup menu for split buttons": "",
    "List Properties": "Vlastnosti Zoznamu",
    "List properties...": "Vlastnosti Zoznamu...",
    "Start list at number": "Začať zoznam číslom",
    "Line height": "Výška riadku",
    "Dropped file type is not supported": "Vkladaný typ súbora nie je podporovaný",
    "Loading...": "Nahrávam...",
    "ImageProxy HTTP error: Rejected request": "",
    "ImageProxy HTTP error: Could not find Image Proxy": "",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "",
    "ImageProxy HTTP error: Unknown ImageProxy error": ""
    });
})();